<template>
  <container-loader v-if="!loaded"></container-loader>
  <div v-else>
    <p v-if="!jobs.length" class="text-center">{{$t('fileJobLog.noJobs')}}</p>
    <div v-else>
      <b-select v-model="selectedJobId" class="inp mb-3" @change="handleChangeJob">
        <option v-for="(job, index) in jobs" :key="index" :value="job.id">
          Job #{{index+1}} - {{job.apps.join(', ')}} ({{job.name}})
        </option>
      </b-select>
      <b-textarea v-model="log" style="width: 100%" rows="15"  read-only></b-textarea>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";
  import {mapActions} from "vuex";
  import ContainerLoader from "../../ContainerLoader";

  export default {
    name: 'file-jobs-log',
    props: {
      fileId: {
        type: [Number, String],
        required: true
      }
    },
    components: {
      ContainerLoader
    },
    data() {
      return {
        loaded: false,
        jobs: [],
        jobLoaded: {},
        jobData: {},
        selectedJobId: null,
        log: ''
      }
    },
    created() {
      this.getFileJobs(this.fileId).then(({data}) => {
        this.loaded = true;
        if (data.success) {
          data.result.jobs.map(job => {
            Vue.set(this.jobLoaded, job.id, false);
            this.jobs.push(job);
          });
          this.selectedJobId = this.jobs[this.jobs.length-1].id;
          this.handleChangeJob();
        }
      });
    },
    methods: {
      ...mapActions(['getFileJobs', 'getFileJobLog']),

      handleChangeJob() {
        this.log = '';
        if (!this.jobLoaded[this.selectedJobId]) {
          this.loadJobLog(this.selectedJobId);
        } else {
          this.log = this.jobData[this.selectedJobId].log;
        }
      },

      loadJobLog(jobId) {
        this.getFileJobLog(jobId).then(({data}) => {
          Vue.set(this.jobLoaded, jobId, true);
          Vue.set(this.jobData, jobId, data);
          if (this.selectedJobId === jobId) {
            this.log = data.log;
          }
        });
      }
    }
  }
</script>
